import React, { Fragment } from 'react';
import './index.style.less';
import PropTypes from 'prop-types';
import AppScrollbar from '../../AppScrollbar';
import AppVerticalMenu from '../components/AppVerticalNav';
import MainSidebar from '../components/MainSidebar';
import {useLocaleContext} from '../../../utility/AppContextProvider/LocaleContextProvide';

const AppSidebar = ({ isCollapsed }) => {
  const { locale, rtlLocale } = useLocaleContext();
  const brandName = rtlLocale.includes(locale.code) ? 'أهلاً' : 'Ahlan';

  return (
    <MainSidebar
      className={'mini-sidebar-toggle'}
      collapsible
      breakpoint='xl'
      collapsedWidth='0'
      collapsed={isCollapsed}>
      <Fragment>
        {/* The store design's brand mark: the bag, then the name. */}
        <div className='logo-sidebar'>
          <img src='/assets/images/ahlan-bag.svg' alt='' />
          <span className='logo-sidebar-name'>{brandName}</span>
        </div>
      </Fragment>
      <AppScrollbar className='app-mini-sidebar-scrollbar' scrollToTop={false}>
        <AppVerticalMenu />
      </AppScrollbar>
    </MainSidebar>
  );
};

export default AppSidebar;

AppSidebar.propTypes = {
  isCollapsed: PropTypes.bool,
};
